import ObjectModelTrigger from "../../../common/models/objectModelTriggers/objectModelTrigger";

export default {
  props: {
    objectModelTrigger: {
      type: ObjectModelTrigger,
      required: true,
    }
  }
};